// Spanish source keys used by contact, agency, company and cookie-consent interfaces.
export const publicFlowMessages = {
  Comenzar: ['Get started', 'Começar'],
  'Empieza por saber': ['Start by learning', 'Comece descobrindo'],
  'cómo te ve la IA hoy.': [
    'how AI sees you today.',
    'como a IA vê você hoje.',
  ],
  'Agendar demo': ['Book a demo', 'Agendar demonstração'],
  'Enviar solicitud': ['Send request', 'Enviar solicitação'],
  '04 / Dudas habituales': ['04 / Common questions', '04 / Dúvidas frequentes'],
  'Antes de': ['Before', 'Antes de'],
  'escribirnos.': ['contacting us.', 'falar com a gente.'],
  'Lo que suelen preguntar quienes están por contactarnos. Si tu duda no está aquí, escríbenos directo.':
    [
      'What people usually ask before contacting us. If your question is not here, write to us directly.',
      'O que as pessoas costumam perguntar antes de entrar em contato. Se sua dúvida não estiver aqui, fale diretamente com a gente.',
    ],
  'D2C retail': ['D2C retail', 'Varejo D2C'],
  'SaaS B2B': ['B2B SaaS', 'SaaS B2B'],
  'Servicios profesionales': [
    'Professional services',
    'Serviços profissionais',
  ],
  'Marca local / regional': [
    'Local / regional brand',
    'Marca local / regional',
  ],
  'E-commerce': ['E-commerce', 'E-commerce'],
  'Plataforma / agencia': ['Platform / agency', 'Plataforma / agência'],
  'No estoy seguro/a': ["I'm not sure", 'Ainda não sei'],
  'El nombre es obligatorio.': ['Name is required.', 'O nome é obrigatório.'],
  'El email es obligatorio.': ['Email is required.', 'O e-mail é obrigatório.'],
  'Ingresa un email válido.': [
    'Enter a valid email address.',
    'Insira um e-mail válido.',
  ],
  'La empresa es obligatoria.': [
    'Company is required.',
    'A empresa é obrigatória.',
  ],
  '01 / Solicitud': ['01 / Request', '01 / Solicitação'],
  '¿Qué necesitas': ['What do you need to', 'O que você precisa'],
  'resolver?': ['solve?', 'resolver?'],
  'Nombre completo': ['Full name', 'Nome completo'],
  'Tu nombre': ['Your name', 'Seu nome'],
  Cargo: ['Job title', 'Cargo'],
  'CMO · Founder · Head of Growth': [
    'CMO · Founder · Head of Growth',
    'CMO · Fundador · Head de Growth',
  ],
  'Email corporativo': ['Work email', 'E-mail corporativo'],
  'tu@empresa.com': ['you@company.com', 'voce@empresa.com'],
  Empresa: ['Company', 'Empresa'],
  'Nombre de la empresa': ['Company name', 'Nome da empresa'],
  'Sitio web': ['Website', 'Site'],
  'https://tuempresa.com': [
    'https://yourcompany.com',
    'https://suaempresa.com',
  ],
  País: ['Country', 'País'],
  'Tipo de empresa': ['Business type', 'Tipo de empresa'],
  'Plan de interés': ['Plan of interest', 'Plano de interesse'],
  '¿Algo más que debamos saber?': [
    'Anything else we should know?',
    'Algo mais que devemos saber?',
  ],
  'Competidores que ya están en LLMs, casos puntuales que viste, deadlines, restricciones de seguridad de tu empresa…':
    [
      "Competitors already appearing in LLMs, specific examples you have seen, deadlines, your company's security restrictions…",
      'Concorrentes que já aparecem em LLMs, exemplos específicos que você viu, prazos, restrições de segurança da sua empresa…',
    ],
  'Recibimos tu solicitud. Te respondemos en menos de 24 h hábiles desde hello@bisonagents.com.':
    [
      'We received your request. We will reply within 24 business hours from hello@bisonagents.com.',
      'Recebemos sua solicitação. Responderemos em até 24 horas úteis pelo hello@bisonagents.com.',
    ],
  'No pudimos enviar tu solicitud. Reintenta o escríbenos a hello@bisonagents.com.':
    [
      "We couldn't send your request. Try again or email hello@bisonagents.com.",
      'Não conseguimos enviar sua solicitação. Tente novamente ou escreva para hello@bisonagents.com.',
    ],
  CONTACTO: ['CONTACT', 'CONTATO'],
  'Respondemos en < 24 h hábiles': [
    'We reply within 24 business hours',
    'Respondemos em até 24 horas úteis',
  ],
  'Hablemos.': ["Let's talk.", 'Vamos conversar.'],
  'Directo.': ['Directly.', 'Direto ao ponto.'],
  'Sin secuencias de email.': [
    'No email sequences.',
    'Sem sequências de e-mail.',
  ],
  'Cuéntanos qué quieres lograr y te respondemos en menos de 24 horas hábiles. Te responde alguien del equipo que conoce el producto, no un guion. La primera llamada es un diagnóstico sin compromiso.':
    [
      'Tell us what you want to achieve and we will reply within 24 business hours. You will hear from someone on the team who knows the product, with no script. The first call is a no-obligation assessment.',
      'Conte o que você quer alcançar e responderemos em até 24 horas úteis. Você fala com alguém da equipe que conhece o produto, sem roteiro. A primeira conversa é um diagnóstico sem compromisso.',
    ],
  'Agendar directo': ['Book directly', 'Agendar diretamente'],
  'Tiempo de respuesta': ['Response time', 'Tempo de resposta'],
  'Hábiles · lunes a viernes': [
    'Business hours · Monday to Friday',
    'Horas úteis · segunda a sexta',
  ],
  'Primera llamada': ['First call', 'Primeira conversa'],
  'Con quien conoce el producto': [
    'With someone who knows the product',
    'Com quem conhece o produto',
  ],
  Permanencia: ['Commitment', 'Fidelidade'],
  'Cancelas cuando quieras': [
    'Cancel whenever you want',
    'Cancele quando quiser',
  ],
  'Costo de la demo': ['Demo cost', 'Custo da demonstração'],
  'Diagnóstico sin compromiso': [
    'No-obligation assessment',
    'Diagnóstico sem compromisso',
  ],
  '03 / Otros canales': ['03 / Other channels', '03 / Outros canais'],
  Contáctanos: ['Contact us', 'Fale com a gente'],
  'como prefieras.': ['however you prefer.', 'como preferir.'],
  Hablemos: ["Let's talk", 'Vamos conversar'],
  Email: ['Email', 'E-mail'],
  Redes: ['Social media', 'Redes sociais'],
  Santiago: ['Santiago', 'Santiago'],
  Oficina: ['Office', 'Escritório'],
  Teléfono: ['Phone', 'Telefone'],
  WhatsApp: ['WhatsApp', 'WhatsApp'],
  'Operamos remoto y atendemos clientes en toda LatAm, sin fronteras de por medio.':
    [
      'We work remotely and serve clients across Latin America, without borders.',
      'Trabalhamos remotamente e atendemos clientes em toda a América Latina, sem fronteiras.',
    ],
  'Demo · 30 min': ['Demo · 30 min', 'Demonstração · 30 min'],
  'Plataforma + tu marca': ['Platform + your brand', 'Plataforma + sua marca'],
  'Cargamos tu sitio en vivo y te mostramos tu diagnóstico AEO baseline: cómo apareces hoy en ChatGPT, Gemini y Perplexity.':
    [
      'We load your website live and show you your AEO baseline assessment: how you appear today in ChatGPT, Gemini and Perplexity.',
      'Carregamos seu site ao vivo e mostramos seu diagnóstico inicial de AEO: como você aparece hoje no ChatGPT, Gemini e Perplexity.',
    ],
  'Deep-dive · 45 min': ['Deep dive · 45 min', 'Conversa técnica · 45 min'],
  'Tu equipo técnico': ['Your technical team', 'Sua equipe técnica'],
  'API, webhooks, residencia de datos y revisión de proveedor. Para cuando seguridad o ingeniería necesitan entrar al detalle.':
    [
      'API, webhooks, data residency and vendor review. For when security or engineering needs to explore the details.',
      'API, webhooks, residência de dados e avaliação de fornecedor. Para quando segurança ou engenharia precisam entrar nos detalhes.',
    ],
  'Agendar deep-dive': ['Book a deep dive', 'Agendar conversa técnica'],
  'Estrategia · 30 min': ['Strategy · 30 min', 'Estratégia · 30 min'],
  'Visión AEO': ['AEO vision', 'Visão de AEO'],
  'Cómo encaja el AEO en tu plan de crecimiento y qué priorizar primero según tu categoría y tus competidores.':
    [
      'How AEO fits into your growth plan and what to prioritize based on your category and competitors.',
      'Como o AEO se encaixa no seu plano de crescimento e o que priorizar conforme sua categoria e seus concorrentes.',
    ],
  'Agendar estrategia': [
    'Book a strategy call',
    'Agendar conversa de estratégia',
  ],
  '02 / Atajo': ['02 / Shortcut', '02 / Atalho'],
  '¿Prefieres agendar': ['Prefer to book', 'Prefere agendar'],
  'directo?': ['directly?', 'diretamente?'],
  '30 minutos.': ['30 minutes.', '30 minutos.'],
  'Si ya viste los casos y los planes, ahórrate el ida y vuelta de email. Agenda en el horario que te acomode y llega directo a la conversación.':
    [
      'If you have already seen the case studies and plans, skip the email back-and-forth. Book a time that suits you and get straight to the conversation.',
      'Se você já viu os casos e os planos, evite a troca de e-mails. Agende no horário mais conveniente e vá direto à conversa.',
    ],
  Postular: ['Apply', 'Inscreva-se'],
  'Cuéntanos de tu agencia.': [
    'Tell us about your agency.',
    'Conte sobre sua agência.',
  ],
  'Te proponemos el nivel.': [
    "We'll suggest the right tier.",
    'Indicaremos o nível ideal.',
  ],
  'Postular al programa': ['Apply to the program', 'Inscrever-se no programa'],
  'Ver la plataforma': ['See the platform', 'Conhecer a plataforma'],
  '¿Hay exclusividad territorial?': [
    'Is there territorial exclusivity?',
    'Existe exclusividade territorial?',
  ],
  'Se conversa caso a caso en el nivel White-label, según país y categoría. En Referral y Reseller no hay exclusividad, pero coordinamos para no competir por las mismas cuentas.':
    [
      'We discuss this case by case at the White-label tier, depending on country and category. Referral and Reseller have no exclusivity, but we coordinate to avoid competing for the same accounts.',
      'Isso é discutido caso a caso no nível White-label, conforme o país e a categoria. Referral e Reseller não têm exclusividade, mas coordenamos para não disputar as mesmas contas.',
    ],
  '¿Puedo usar el nombre y logo de Bison en mis propuestas?': [
    "Can I use Bison's name and logo in my proposals?",
    'Posso usar o nome e o logo da Bison nas minhas propostas?',
  ],
  'En Referral y Reseller puedes referenciar a Bison con el badge oficial del programa. En White-label operas con tu propia marca — Bison no aparece en los entregables al cliente.':
    [
      'In Referral and Reseller, you can reference Bison using the official program badge. With White-label, you operate under your own brand — Bison does not appear in client deliverables.',
      'Nos níveis Referral e Reseller, você pode citar a Bison com o selo oficial do programa. No White-label, você opera com sua própria marca — a Bison não aparece nas entregas ao cliente.',
    ],
  '¿Cómo funciona el proceso de postulación?': [
    'How does the application process work?',
    'Como funciona o processo de inscrição?',
  ],
  'Nos escribes desde la página de contacto, conversamos en una llamada con el equipo y te proponemos el nivel que mejor encaja con tu agencia.':
    [
      'Contact us through the contact page, have a call with the team, and we will suggest the tier that best fits your agency.',
      'Escreva pela página de contato, converse com a equipe em uma chamada e indicaremos o nível mais adequado para sua agência.',
    ],
  '¿Puedo cambiar de nivel después?': [
    'Can I change tiers later?',
    'Posso mudar de nível depois?',
  ],
  'Sí. Puedes empezar como Referral y pasar a Reseller o White-label cuando sumes clientes con AEO en producción. El cambio se acuerda como anexo al contrato.':
    [
      'Yes. You can start as a Referral partner and move to Reseller or White-label as you add clients using AEO in production. The change is agreed in a contract addendum.',
      'Sim. Você pode começar como Referral e passar a Reseller ou White-label à medida que conquistar clientes com AEO em produção. A mudança é formalizada em um aditivo contratual.',
    ],
  '¿Cuánto tiempo lleva activar el primer cliente?': [
    'How long does it take to activate the first client?',
    'Quanto tempo leva para ativar o primeiro cliente?',
  ],
  'Depende del nivel y de la certificación. En la primera conversación te proponemos un plan de activación con fechas concretas.':
    [
      'It depends on the tier and certification. In our first conversation, we will propose an activation plan with specific dates.',
      'Depende do nível e da certificação. Na primeira conversa, propomos um plano de ativação com datas concretas.',
    ],
  '¿Pueden operar en distintos países de LatAm?': [
    'Can you operate in different Latin American countries?',
    'Vocês podem operar em diferentes países da América Latina?',
  ],
  'Sí. El programa está abierto a agencias de toda LatAm. Facturamos desde Chile, en CLP o USD.':
    [
      'Yes. The program is open to agencies across Latin America. We invoice from Chile, in CLP or USD.',
      'Sim. O programa está aberto a agências de toda a América Latina. Faturamos a partir do Chile, em CLP ou USD.',
    ],
  '06 / Dudas habituales': ['06 / Common questions', '06 / Dúvidas frequentes'],
  'Lo que toda agencia': ['What every agency', 'O que toda agência'],
  pregunta: ['asks', 'pergunta'],
  'antes de postular.': ['before applying.', 'antes de se inscrever.'],
  'Si tu duda no está aquí, escríbenos.': [
    'If your question is not here, write to us.',
    'Se sua dúvida não estiver aqui, fale com a gente.',
  ],
  'PROGRAMA PARA AGENCIAS': ['AGENCY PROGRAM', 'PROGRAMA PARA AGÊNCIAS'],
  '3 niveles': ['3 tiers', '3 níveis'],
  'Tus clientes ya': ['Your clients are already', 'Seus clientes já'],
  preguntan: ['asking', 'perguntam'],
  'por AEO.': ['about AEO.', 'sobre AEO.'],
  'Un programa para agencias de SEO, branding y marketing digital que ya tienen la relación con el cliente y no quieren construir su propio stack de AEO. Tres niveles pensados para encajar en tu modelo comercial.':
    [
      "A program for SEO, branding and digital marketing agencies that already have the client relationship and don't want to build their own AEO stack. Three tiers designed to fit your business model.",
      'Um programa para agências de SEO, branding e marketing digital que já têm o relacionamento com o cliente e não querem construir sua própria estrutura de AEO. Três níveis pensados para o seu modelo comercial.',
    ],
  'Ver los 3 niveles': ['See all 3 tiers', 'Conhecer os 3 níveis'],
  Niveles: ['Tiers', 'Níveis'],
  'Referral · Reseller · White-label': [
    'Referral · Reseller · White-label',
    'Referral · Reseller · White-label',
  ],
  Modelo: ['Model', 'Modelo'],
  'Comisión o margen según el nivel': [
    'Commission or margin depending on tier',
    'Comissão ou margem conforme o nível',
  ],
  Formación: ['Training', 'Formação'],
  'Ruta de certificación por nivel': [
    'Certification path for each tier',
    'Trilha de certificação por nível',
  ],
  Cobertura: ['Coverage', 'Cobertura'],
  'Postulaciones abiertas en toda la región': [
    'Applications open across the region',
    'Inscrições abertas em toda a região',
  ],
  'Ingreso recurrente': ['Recurring revenue', 'Receita recorrente'],
  'Comisión o margen mensual mientras el cliente siga activo.': [
    'Monthly commission or margin for as long as the client remains active.',
    'Comissão ou margem mensal enquanto o cliente estiver ativo.',
  ],
  'Co-marketing': ['Co-marketing', 'Co-marketing'],
  'Webinars y casos compartidos que posicionan a tu agencia como referente de AEO en tu país.':
    [
      'Joint webinars and case studies that establish your agency as an AEO authority in your country.',
      'Webinars e casos em conjunto que posicionam sua agência como referência em AEO no seu país.',
    ],
  'Formación continua': ['Ongoing training', 'Formação contínua'],
  'Acceso a las certificaciones y a las actualizaciones de la biblioteca de acciones cuando sumamos motores.':
    [
      'Access to certifications and updates to the action library as we add engines.',
      'Acesso às certificações e às atualizações da biblioteca de ações quando adicionamos novos motores.',
    ],
  'Canal directo': ['Direct channel', 'Canal direto'],
  'Contacto con el equipo técnico de Bison, sin tickets, con alguien que conoce tus cuentas.':
    [
      "Contact with Bison's technical team, with no ticket queue and someone who knows your accounts.",
      'Contato com a equipe técnica da Bison, sem fila de chamados, com alguém que conhece suas contas.',
    ],
  'Leads entrantes': ['Inbound leads', 'Leads recebidos'],
  'Cuando nos escriben marcas de tu país o categoría que buscan agencia, podemos derivarlas a ti.':
    [
      'When brands in your country or category contact us looking for an agency, we can refer them to you.',
      'Quando marcas do seu país ou categoria nos procuram em busca de uma agência, podemos encaminhá-las a você.',
    ],
  'Early access': ['Early access', 'Acesso antecipado'],
  'Acceso anticipado a los motores y módulos nuevos antes de su lanzamiento general.':
    [
      'Early access to new engines and modules before their general release.',
      'Acesso antecipado a novos motores e módulos antes do lançamento geral.',
    ],
  'API y webhooks': ['API and webhooks', 'API e webhooks'],
  'Integra los datos de Bison en tu propia plataforma de reporting o tu dashboard de agencia. Reseller en adelante.':
    [
      "Integrate Bison's data into your own reporting platform or agency dashboard. Available from Reseller onward.",
      'Integre os dados da Bison à sua plataforma de relatórios ou ao dashboard da agência. Disponível a partir do nível Reseller.',
    ],
  'Sin conflicto de canal': ['No channel conflict', 'Sem conflito de canal'],
  'Coordinamos contigo antes de trabajar directo con una marca de tu cartera.':
    [
      'We coordinate with you before working directly with a brand in your portfolio.',
      'Coordenamos com você antes de trabalhar diretamente com uma marca da sua carteira.',
    ],
  '05 / Beneficios': ['05 / Benefits', '05 / Benefícios'],
  'Lo que un partner recibe más allá de': [
    'What a partner gets beyond',
    'O que um parceiro recebe além de',
  ],
  'la comisión.': ['the commission.', 'a comissão.'],
  'Una agencia no se queda por la comisión. Se queda porque el partnership le da ventaja real con sus clientes.':
    [
      "An agency doesn't stay for the commission. It stays because the partnership gives it a real advantage with clients.",
      'Uma agência não fica pela comissão. Fica porque a parceria oferece uma vantagem real com seus clientes.',
    ],
  'CERT 01 · FUNDAMENTOS': ['CERT 01 · FOUNDATIONS', 'CERT 01 · FUNDAMENTOS'],
  'AEO Foundations': ['AEO Foundations', 'Fundamentos de AEO'],
  'Para que tu equipo de cuentas pueda hablar de AEO con un CMO sin improvisar: los motores, el Score de visibilidad, las 4 dimensiones del diagnóstico y los mínimos de identidad.':
    [
      'So your account team can discuss AEO with a CMO confidently: the engines, visibility Score, four assessment dimensions and identity essentials.',
      'Para sua equipe de contas falar de AEO com um CMO com segurança: os motores, o Score de visibilidade, as quatro dimensões do diagnóstico e os requisitos de identidade.',
    ],
  'CERT 02 · OPERACIÓN': ['CERT 02 · OPERATIONS', 'CERT 02 · OPERAÇÃO'],
  'Playbook Operativo': ['Operational Playbook', 'Playbook Operacional'],
  'Para que tu equipo active la biblioteca de acciones en cuentas reales. Incluye un caso guiado de principio a fin.':
    [
      'So your team can activate the action library in real accounts. Includes an end-to-end guided case.',
      'Para sua equipe aplicar a biblioteca de ações em contas reais. Inclui um caso guiado do início ao fim.',
    ],
  'CERT 03 · MASTER': ['CERT 03 · MASTER', 'CERT 03 · MASTER'],
  'Master Partner': ['Master Partner', 'Master Partner'],
  'Para quien lidera AEO en tu agencia: API, conectores y operación avanzada. Se aprueba con un caso entregable.':
    [
      'For whoever leads AEO at your agency: API, connectors and advanced operations. Passing requires a completed case deliverable.',
      'Para quem lidera AEO na sua agência: API, conectores e operação avançada. A aprovação exige a entrega de um caso prático.',
    ],
  '04 / Certificación': ['04 / Certification', '04 / Certificação'],
  'Tres certificaciones.': ['Three certifications.', 'Três certificações.'],
  Una: ['One', 'Uma'],
  'sola taxonomía.': ['shared taxonomy.', 'única taxonomia.'],
  'Las certificaciones son la única barrera técnica del programa y la condición para subir de nivel. Cada una se aprueba con un caso práctico.':
    [
      "Certifications are the program's only technical requirement and the condition for moving up a tier. Each is earned through a practical case.",
      'As certificações são o único requisito técnico do programa e a condição para subir de nível. Cada uma é obtida com um caso prático.',
    ],
  'AGENCIA PARTNER': ['PARTNER AGENCY', 'AGÊNCIA PARCEIRA'],
  'La relación, el contexto y la ejecución comercial.': [
    'The relationship, context and sales execution.',
    'O relacionamento, o contexto e a execução comercial.',
  ],
  'Cuenta del cliente: contrato, facturación, relación senior.': [
    'Client account: contract, invoicing and senior relationship.',
    'Conta do cliente: contrato, faturamento e relacionamento sênior.',
  ],
  'Contexto de marca: ICP, tono editorial, lo que se ha probado antes.': [
    'Brand context: ICP, editorial voice and what has been tried before.',
    'Contexto de marca: ICP, tom editorial e o que já foi testado.',
  ],
  'Ejecución de las acciones que requieren creatividad (medios de autoridad, contenido largo, redes).':
    [
      'Execution of actions that require creativity (authoritative media, long-form content, social media).',
      'Execução das ações que exigem criatividade (mídia de autoridade, conteúdo longo e redes sociais).',
    ],
  'Presentación trimestral del reporte al cliente.': [
    'Quarterly report presentation to the client.',
    'Apresentação trimestral do relatório ao cliente.',
  ],
  'Bison Agents': ['Bison Agents', 'Bison Agents'],
  'La capa técnica, el método y la baseline AEO.': [
    'The technical layer, methodology and AEO baseline.',
    'A camada técnica, o método e a referência inicial de AEO.',
  ],
  'Plataforma de monitoreo en los principales motores generativos.': [
    'Monitoring platform for the leading generative engines.',
    'Plataforma de monitoramento dos principais motores generativos.',
  ],
  'Diagnóstico 4D (0–100) con las brechas priorizadas según el tipo de marca.':
    [
      '4D assessment (0–100) with gaps prioritized by brand type.',
      'Diagnóstico 4D (0–100) com lacunas priorizadas conforme o tipo de marca.',
    ],
  'Biblioteca de 25 acciones con esfuerzo, impacto y señal de activación.': [
    'Library of 25 actions with effort, impact and activation signals.',
    'Biblioteca de 25 ações com esforço, impacto e sinal de ativação.',
  ],
  'Reportes ejecutivos co-branded o con tu marca.': [
    'Co-branded or own-brand executive reports.',
    'Relatórios executivos com as duas marcas ou com a sua.',
  ],
  '02 / Qué aportas tú, qué aportamos nosotros': [
    '02 / What you bring, what we bring',
    '02 / O que você traz, o que nós trazemos',
  ],
  'Una división del trabajo': [
    'A division of work that is',
    'Uma divisão do trabalho',
  ],
  'simple.': ['simple.', 'simples.'],
  'Tú tienes la relación con la marca. Nosotros ponemos la medición, la biblioteca de acciones y reportes que pasan el filtro de un CMO técnico. Cada parte hace lo que mejor sabe hacer.':
    [
      "You have the brand relationship. We provide measurement, the action library and reports that stand up to a technical CMO's scrutiny. Each side does what it does best.",
      'Você tem o relacionamento com a marca. Nós oferecemos a medição, a biblioteca de ações e relatórios que passam pelo crivo de um CMO técnico. Cada parte faz o que sabe fazer melhor.',
    ],
  '"Nuestro tráfico orgánico bajó y no cambiamos nada."': [
    '"Our organic traffic dropped and we didn\'t change anything."',
    '"Nosso tráfego orgânico caiu e não mudamos nada."',
  ],
  'Muchas veces la causa no está en el ranking clásico, sino en las respuestas de IA que se quedan con el clic. Lo que antes ranqueaba ahora se cita o se ignora, y nadie en tu equipo está midiendo esa diferencia.':
    [
      "Often the cause isn't traditional rankings, but AI answers that capture the click. What used to rank is now cited or ignored, and no one on your team is measuring that difference.",
      'Muitas vezes, a causa não está no ranking tradicional, mas nas respostas de IA que ficam com o clique. O que antes ranqueava agora é citado ou ignorado, e ninguém na sua equipe mede essa diferença.',
    ],
  '"¿Aparecemos en ChatGPT? ¿Cuánto cuesta optimizarlo?"': [
    '"Do we appear in ChatGPT? How much does optimization cost?"',
    '"Aparecemos no ChatGPT? Quanto custa otimizar isso?"',
  ],
  'Cuando el CMO pregunta esto en la reunión mensual, no quiere una opinión: quiere un número. Responder "déjame ver" cuesta credibilidad con la cuenta.':
    [
      'When the CMO asks this in the monthly meeting, they don\'t want an opinion: they want a number. Answering "let me check" costs credibility with the account.',
      'Quando o CMO pergunta isso na reunião mensal, não quer uma opinião: quer um número. Responder "vou verificar" custa credibilidade com a conta.',
    ],
  '"Otra agencia nos ofreció un dashboard que mide AEO."': [
    '"Another agency offered us a dashboard that measures AEO."',
    '"Outra agência nos ofereceu um dashboard que mede AEO."',
  ],
  'Construir infraestructura propia para medir varios motores toma meses y un equipo de datos que probablemente no tienes. Asociarte con quien ya la construyó es mucho más rápido.':
    [
      "Building your own infrastructure to measure multiple engines takes months and a data team you probably don't have. Partnering with someone who has already built it is much faster.",
      'Construir infraestrutura própria para medir vários motores leva meses e exige uma equipe de dados que você provavelmente não tem. Fazer parceria com quem já construiu isso é muito mais rápido.',
    ],
  '01 / El Problema de las Agencias': [
    '01 / The agency challenge',
    '01 / O desafio das agências',
  ],
  'Tres conversaciones': ['Three conversations', 'Três conversas'],
  'que ya tuviste este mes.': [
    "you've already had this month.",
    'que você já teve este mês.',
  ],
  'El SEO sigue siendo la base, pero tus clientes ya quieren saber qué dice la IA de ellos. Si todavía no te lo preguntan, lo harán pronto. Puedes construir capacidad interna, arriesgar la cuenta frente a otra agencia o asociarte con quien ya lo resolvió.':
    [
      "SEO remains the foundation, but your clients already want to know what AI says about them. If they haven't asked yet, they will soon. You can build internal capabilities, risk losing the account to another agency or partner with someone who has solved it.",
      'O SEO continua sendo a base, mas seus clientes já querem saber o que a IA diz sobre eles. Se ainda não perguntaram, perguntarão em breve. Você pode construir capacidade interna, arriscar perder a conta para outra agência ou fazer parceria com quem já resolveu isso.',
    ],
  '03 / Tres niveles': ['03 / Three tiers', '03 / Três níveis'],
  'Empieza por': ['Start with', 'Comece com'],
  'Referral.': ['Referral.', 'Referral.'],
  'Sube cuando tengas señal.': [
    'Move up when the signals are there.',
    'Avance quando houver sinais.',
  ],
  'Los tres niveles son una escalera, no categorías excluyentes. Puedes entrar como Referral y subir a Reseller o White-label a medida que sumas clientes con AEO en producción. Comisiones y márgenes son a medida: se acuerdan con cada agencia.':
    [
      'The three tiers are a progression, not exclusive categories. Start as a Referral partner and move to Reseller or White-label as you add clients using AEO in production. Commissions and margins are tailored and agreed with each agency.',
      'Os três níveis são uma progressão, não categorias excludentes. Você pode entrar como Referral e avançar para Reseller ou White-label conforme conquistar clientes com AEO em produção. Comissões e margens são personalizadas e acordadas com cada agência.',
    ],
  'vs. una agencia': ['vs. an agency', 'vs. uma agência'],
  'Te entrega un PDF de recomendaciones y te factura horas; la ejecución queda de tu lado.':
    [
      'Delivers a PDF of recommendations and bills you for hours; execution is up to you.',
      'Entrega um PDF de recomendações e cobra por hora; a execução fica por sua conta.',
    ],
  'Software que ejecuta y mide cada semana, no por proyecto. Operadores, no consultores.':
    [
      'Software that executes and measures every week, rather than per project. Operators, not consultants.',
      'Software que executa e mede toda semana, e não por projeto. Operadores, não consultores.',
    ],
  'vs. un tracker de IA': ['vs. an AI tracker', 'vs. um rastreador de IA'],
  'Te muestra un dashboard de menciones y ahí termina su trabajo.': [
    'Shows you a mentions dashboard and stops there.',
    'Mostra um dashboard de menções e para por aí.',
  ],
  'Cierra el ciclo: diagnostica la brecha, genera el contenido para cerrarla y posiciona.':
    [
      'Closes the loop: diagnoses the gap, creates content to close it and improves positioning.',
      'Fecha o ciclo: diagnostica a lacuna, gera o conteúdo para preenchê-la e melhora o posicionamento.',
    ],
  'vs. tu stack actual': ['vs. your current stack', 'vs. sua estrutura atual'],
  'GA4 mide tu tráfico humano y el SEO tradicional pelea tu ranking de enlaces, cada uno por su lado.':
    [
      'GA4 measures human traffic and traditional SEO fights for link rankings, each on its own.',
      'O GA4 mede seu tráfego humano e o SEO tradicional disputa seu ranking de links, cada um por conta própria.',
    ],
  'Reúne el SEO y la visibilidad en IA en un solo lugar: audita la base técnica, lee Search Console y mide si la IA te cita y te recomienda.':
    [
      'Brings SEO and AI visibility together: audits your technical foundations, reads Search Console and measures whether AI cites and recommends you.',
      'Reúne SEO e visibilidade em IA em um só lugar: audita a base técnica, lê o Search Console e mede se a IA cita e recomenda sua marca.',
    ],
  '04 / Diferenciadores': ['04 / What sets us apart', '04 / Diferenciais'],
  'Por qué Bison,': ['Why Bison,', 'Por que Bison,'],
  'y no lo de siempre.': ['and something different.', 'e uma nova abordagem.'],
  'Hay muchas formas de gastar en visibilidad. Esta es la diferencia entre lo que ya conoces y lo que hace Bison.':
    [
      'There are many ways to spend on visibility. This is the difference between what you know and what Bison does.',
      'Há muitas formas de investir em visibilidade. Esta é a diferença entre o que você já conhece e o que a Bison faz.',
    ],
  'Con Bison': ['With Bison', 'Com Bison'],
  'Seguimiento semanal': ['Weekly tracking', 'Acompanhamento semanal'],
  'Rastrea cada mención, cita y tu share-of-voice en más de 10 motores de IA.':
    [
      'Tracks every mention, citation and your share of voice across more than 10 AI engines.',
      'Rastreia cada menção, citação e seu share of voice em mais de 10 motores de IA.',
    ],
  'Análisis de datos': ['Data analysis', 'Análise de dados'],
  'Te pone una nota 0–100 en 4 dimensiones y prioriza las brechas por impacto.':
    [
      'Scores you from 0–100 across four dimensions and prioritizes gaps by impact.',
      'Atribui uma nota de 0–100 em quatro dimensões e prioriza as lacunas por impacto.',
    ],
  'Producción editorial': ['Editorial production', 'Produção editorial'],
  'Crea las piezas —FAQs, artículos, comparativas— que la IA necesita para citarte.':
    [
      'Creates the FAQs, articles and comparisons AI needs to cite you.',
      'Cria FAQs, artigos e comparativos que a IA precisa para citar sua marca.',
    ],
  'Ejecución continua': ['Continuous execution', 'Execução contínua'],
  'Aplica las acciones del playbook, una a una, mide el resultado y ajusta el rumbo.':
    [
      'Applies playbook actions one by one, measures results and adjusts course.',
      'Aplica as ações do playbook uma a uma, mede os resultados e ajusta o rumo.',
    ],
  '03 / Equipo': ['03 / Team', '03 / Equipe'],
  'Tres fundadores.': ['Three founders.', 'Três fundadores.'],
  'El resto,': ['The rest,', 'O restante,'],
  'agentes.': ['agents.', 'agentes.'],
  'Un equipo técnico de primer nivel —ingeniería, datos y producto— que define la estrategia, apoyado por agentes de IA que ejecutan el trabajo repetible a escala.':
    [
      'A top technical team in engineering, data and product sets the strategy, supported by AI agents that perform repeatable work at scale.',
      'Uma equipe técnica de alto nível em engenharia, dados e produto define a estratégia, apoiada por agentes de IA que executam o trabalho repetitivo em escala.',
    ],
  Fundadores: ['Founders', 'Fundadores'],
  Asesoría: ['Advisors', 'Assessoria'],
  'Agentes de IA': ['AI agents', 'Agentes de IA'],
  '01 / Historia': ['01 / Our story', '01 / Nossa história'],
  'Construimos la plataforma que nos hubiera gustado': [
    'We built the platform we wished we could',
    'Construímos a plataforma que gostaríamos de',
  ],
  'contratar.': ['hire.', 'contratar.'],
  'Antes de Bison fundamos, escalamos y vendimos empresas de tecnología. Desde esa trinchera vimos repetirse el mismo cambio: los clientes dejaron de recorrer diez enlaces azules y empezaron a preguntarle directo a ChatGPT, Gemini y Perplexity. La decisión de compra se movió hacia adentro de la respuesta.':
    [
      'Before Bison, we founded, scaled and sold technology companies. From that vantage point, we watched the same shift unfold: customers stopped browsing ten blue links and started asking ChatGPT, Gemini and Perplexity directly. Purchase decisions moved inside the answer.',
      'Antes da Bison, fundamos, expandimos e vendemos empresas de tecnologia. Dessa posição, vimos a mesma mudança se repetir: os clientes pararam de percorrer dez links azuis e começaram a perguntar diretamente ao ChatGPT, Gemini e Perplexity. A decisão de compra passou para dentro da resposta.',
    ],
  'Las herramientas que conocíamos medían SEO —rankings, backlinks, tráfico— pero eran ciegas a lo que de verdad importaba ahora:':
    [
      'The tools we knew measured SEO — rankings, backlinks and traffic — but missed what really mattered now:',
      'As ferramentas que conhecíamos mediam SEO — rankings, backlinks e tráfego — mas não enxergavam o que realmente importava agora:',
    ],
  'si la IA mencionaba tu marca, qué decía de ella y a quién citaba en tu lugar.':
    [
      'whether AI mentioned your brand, what it said about it and who it cited instead.',
      'se a IA mencionava sua marca, o que dizia sobre ela e quem citava no seu lugar.',
    ],
  'No existía un instrumento para esa capa nueva.': [
    'There was no tool for this new layer.',
    'Não existia uma ferramenta para essa nova camada.',
  ],
  'En octubre de 2025 fundamos Bison Agents. No como agencia, sino como software: una plataforma para medir, diagnosticar, generar el contenido que cierra las brechas y posicionar a una marca dentro de las respuestas de la IA, con una metodología repetible en cualquier industria.':
    [
      'We founded Bison Agents in October 2025. As software: a platform to measure, diagnose, generate content that closes gaps and position a brand inside AI answers, with a methodology repeatable across industries.',
      'Fundamos a Bison Agents em outubro de 2025. Como software: uma plataforma para medir, diagnosticar, gerar conteúdo que preenche lacunas e posicionar uma marca nas respostas da IA, com uma metodologia replicável em qualquer setor.',
    ],
  'Por qué Bison': ['Why Bison', 'Por que Bison'],
  'El bisonte aguantó hasta el último tiro porque era el animal correcto en el ecosistema equivocado. La metáfora es inversa pero la lección es la misma: en la nueva capa de búsqueda, las marcas correctas sin la presencia correcta también se extinguen. Existimos para que eso no le pase a las nuestras.':
    [
      'The bison held on until the last shot because it was the right animal in the wrong ecosystem. The metaphor is reversed, but the lesson is the same: in the new search layer, the right brands without the right presence also disappear. We exist to keep that from happening to ours.',
      'O bisão resistiu até o último tiro porque era o animal certo no ecossistema errado. A metáfora é inversa, mas a lição é a mesma: na nova camada de busca, as marcas certas sem a presença certa também desaparecem. Existimos para que isso não aconteça com as nossas.',
    ],
  Misión: ['Mission', 'Missão'],
  'Darle a cada marca el instrumento que faltaba: medir su presencia en los motores de IA, diagnosticar sus brechas y cerrarlas con contenido y acciones concretas, ejecutadas con software propio y un método repetible.':
    [
      'Give every brand the missing tool: measure its presence in AI engines, diagnose gaps and close them with content and concrete actions, executed with our own software and a repeatable method.',
      'Dar a cada marca a ferramenta que faltava: medir sua presença nos motores de IA, diagnosticar lacunas e preenchê-las com conteúdo e ações concretas, executadas com software próprio e um método replicável.',
    ],
  Visión: ['Vision', 'Visão'],
  'Que gestionar la visibilidad dentro de las respuestas de la IA sea tan medible y rutinario como lo fue el SEO, y que Bison sea el estándar con que las marcas de LatAm lo hacen.':
    [
      'Make managing visibility inside AI answers as measurable and routine as SEO, with Bison as the standard Latin American brands use to do it.',
      'Tornar a gestão da visibilidade nas respostas da IA tão mensurável e rotineira quanto o SEO, com a Bison como o padrão usado pelas marcas da América Latina.',
    ],
  'Mapa de Sudamérica con Chile —sede de Bison Agents— destacado; mercados atendidos: Colombia, Argentina, Perú y Uruguay.':
    [
      "Map of South America highlighting Chile, Bison Agents' headquarters; markets served: Colombia, Argentina, Peru and Uruguay.",
      'Mapa da América do Sul com destaque para o Chile, sede da Bison Agents; mercados atendidos: Colômbia, Argentina, Peru e Uruguai.',
    ],
  'Operamos lo que recomendamos. Construimos el sistema que hace que la': [
    'We put our recommendations into practice. We build the system that makes',
    'Colocamos em prática o que recomendamos. Construímos o sistema que faz a',
  ],
  'IA hable de tu marca.': [
    'AI talk about your brand.',
    'IA falar da sua marca.',
  ],
  Manifiesto: ['Manifesto', 'Manifesto'],
  '· Bison Agents': ['· Bison Agents', '· Bison Agents'],
  '06 / En los medios': ['06 / In the media', '06 / Na mídia'],
  'Nuestros datos,': ['Our data,', 'Nossos dados,'],
  'citados por la prensa.': ['cited by the press.', 'citados pela imprensa.'],
  'Medios que han publicado nuestras mediciones. Cada nota enlaza a su fuente original y a los datos completos en el blog.':
    [
      'Media outlets that have published our measurements. Each story links to its original source and the full data on our blog.',
      'Veículos que publicaram nossas medições. Cada notícia leva à fonte original e aos dados completos no blog.',
    ],
  'La nota resume el estudio; en el blog publicamos los datos completos.': [
    'The story summarizes the study; we publish the full data on our blog.',
    'A notícia resume o estudo; publicamos os dados completos no blog.',
  ],
  'Ver los datos de las 22 industrias': [
    'See data for all 22 industries',
    'Ver os dados dos 22 setores',
  ],
  'Ver los datos de las 12 industrias': [
    'See data for all 12 industries',
    'Ver os dados dos 12 setores',
  ],
  'Cuando la IA habla de sustentabilidad, aparecer no es lo mismo que ser referente':
    [
      'When AI talks about sustainability, appearing is not the same as being a reference',
      'Quando a IA fala de sustentabilidade, aparecer não é o mesmo que ser referência',
    ],
  'Atribuye a Bison Agents el Ranking de sustentabilidad en IA: 468 respuestas de ChatGPT, Claude y Gemini sobre 180 empresas en 12 industrias. Enlaza al artículo y al ranking completo.':
    [
      'Attributes the AI Sustainability Ranking to Bison Agents: 468 answers from ChatGPT, Claude and Gemini on 180 companies across 12 industries. It links to the article and the full ranking.',
      'Atribui à Bison Agents o Ranking de sustentabilidade em IA: 468 respostas do ChatGPT, Claude e Gemini sobre 180 empresas em 12 setores. Inclui links para o artigo e para o ranking completo.',
    ],
  Conversemos: ["Let's talk", 'Vamos conversar'],
  '¿Listo para que la IA': ['Ready for AI to', 'Pronto para a IA'],
  'hable de tu marca?': ['talk about your brand?', 'falar da sua marca?'],
  'Ver planes': ['View plans', 'Ver planos'],
  '08 / Sobre Bison': ['08 / About Bison', '08 / Sobre a Bison'],
  'Preguntas frecuentes': [
    'Frequently asked questions',
    'Perguntas frequentes',
  ],
  sobre: ['about', 'sobre'],
  'Bison.': ['Bison.', 'a Bison.'],
  'Lo que suelen preguntar quienes quieren entender quiénes están detrás y cómo trabajamos.':
    [
      'What people usually ask when they want to understand who is behind Bison and how we work.',
      'O que as pessoas costumam perguntar para entender quem está por trás da Bison e como trabalhamos.',
    ],
  NOSOTROS: ['ABOUT US', 'SOBRE NÓS'],
  'Santiago · Chile · LatAm': [
    'Santiago · Chile · Latin America',
    'Santiago · Chile · América Latina',
  ],
  Operadores: ['Operators', 'Operadores'],
  antes: ['before', 'antes'],
  'que consultores.': ['consultants.', 'de consultores.'],
  'Fundadores que ya construyeron, escalaron y vendieron empresas. Levantamos Bison porque la próxima búsqueda no se gana con backlinks, sino con citas en las respuestas de la IA — y construimos la plataforma para lograrlo en LatAm.':
    [
      'Founders who have already built, scaled and sold companies. We started Bison because the next search is won through citations in AI answers, and built the platform to make it happen in Latin America.',
      'Fundadores que já construíram, expandiram e venderam empresas. Criamos a Bison porque a próxima busca se conquista com citações nas respostas da IA e construímos a plataforma para chegar lá na América Latina.',
    ],
  'Ver casos de estudio': ['View case studies', 'Ver casos de sucesso'],
  Fundada: ['Founded', 'Fundada'],
  'Octubre · Santiago': ['October · Santiago', 'Outubro · Santiago'],
  Equipo: ['Team', 'Equipe'],
  'Fundadores + agentes de IA': [
    'Founders + AI agents',
    'Fundadores + agentes de IA',
  ],
  Mercado: ['Market', 'Mercado'],
  'Expansión LatAm 2026': [
    'Latin American expansion 2026',
    'Expansão na América Latina em 2026',
  ],
  'Empresas previas': ['Previous companies', 'Empresas anteriores'],
  'Del equipo fundador': ['From the founding team', 'Da equipe fundadora'],
  'Chile · Headquarter': ['Chile · Headquarters', 'Chile · Sede'],
  '07 / Dónde estamos': ['07 / Where we are', '07 / Onde estamos'],
  'Sede en Santiago,': ['Based in Santiago,', 'Sede em Santiago,'],
  'alcance LatAm.': ['reaching Latin America.', 'alcance na América Latina.'],
  'Operamos desde Santiago de Chile y atendemos clientes en toda LatAm, sin fronteras de por medio.':
    [
      'We operate from Santiago, Chile, and serve clients across Latin America, without borders.',
      'Operamos a partir de Santiago do Chile e atendemos clientes em toda a América Latina, sem fronteiras.',
    ],
  Síguenos: ['Follow us', 'Siga a gente'],
  'Comunidad Bison': ['Bison community', 'Comunidade Bison'],
  Blog: ['Blog', 'Blog'],
  'Lo que': ['What we', 'O que'],
  'compartimos.': ['share.', 'compartilhamos.'],
  'Publicamos ensayos y tips sobre AEO y motores generativos. Todo vive en nuestro blog.':
    [
      'We publish essays and tips about AEO and generative engines. It all lives on our blog.',
      'Publicamos artigos e dicas sobre AEO e motores generativos. Tudo está no nosso blog.',
    ],
  'Ensayos largos y tips cortos.': [
    'Long essays and short tips.',
    'Artigos longos e dicas curtas.',
  ],
  'Ver artículos y tips': ['View articles and tips', 'Ver artigos e dicas'],
  Respaldo: ['Backing', 'Apoio'],
  'Inversionistas a bordo': ['Investors on board', 'Investidores a bordo'],
  'Score AEO propio': ['Our own AEO Score', 'Score AEO próprio'],
  'Público — aplicado en Bison': [
    'Public — measured on Bison',
    'Público — aplicado na Bison',
  ],
  Segmentos: ['Segments', 'Segmentos'],
  'Metodología replicable': [
    'Repeatable methodology',
    'Metodologia replicável',
  ],
  '05 / Respaldo': ['05 / Backing', '05 / Apoio'],
  'Temprano,': ['Early stage,', 'No início,'],
  'con tracción real.': ['with real traction.', 'com tração real.'],
  'Somos una empresa joven y enfocada. Estas son las señales concretas y verificables de que la apuesta está funcionando — los números reales, sin inflar nada.':
    [
      'We are a young, focused company. These are concrete, verifiable signs that the bet is working — real numbers, with no inflation.',
      'Somos uma empresa jovem e focada. Estes são os sinais concretos e verificáveis de que a aposta está funcionando — números reais, sem exageros.',
    ],
  'Cada señal es auditable.': [
    'Every signal is auditable.',
    'Cada sinal é auditável.',
  ],
  'Ver todos los casos': ['View all case studies', 'Ver todos os casos'],
  Técnica: ['Technical', 'Técnica'],
  'Datos, métricas, evidencia. Si no se mide, no se afirma. Si no se afirma, no se promete.':
    [
      "Data, metrics, evidence. If it isn't measured, we don't claim it. If we can't support it, we don't promise it.",
      'Dados, métricas, evidências. Se não medimos, não afirmamos. Se não podemos afirmar, não prometemos.',
    ],
  Experta: ['Expert', 'Especialista'],
  'Hablamos desde el dominio. Si no sabemos algo, lo investigamos antes de opinar.':
    [
      "We speak from expertise. If we don't know something, we research it before offering an opinion.",
      'Falamos com conhecimento. Se não sabemos algo, pesquisamos antes de opinar.',
    ],
  Premium: ['Premium', 'Premium'],
  'Estética sobria, ritmo controlado, foco. No competimos por volumen ni por velocidad.':
    [
      "Understated design, measured pace, focus. We don't compete on volume or speed.",
      'Estética sóbria, ritmo controlado, foco. Não competimos por volume ou velocidade.',
    ],
  Vanguardista: ['Forward-thinking', 'Vanguardista'],
  'Llegamos primero al tema. Educamos al mercado mientras lo capturamos.': [
    'We get to the topic first. We educate the market as we win it.',
    'Chegamos primeiro ao tema. Educamos o mercado enquanto conquistamos espaço.',
  ],
  Confiable: ['Reliable', 'Confiável'],
  'Tono sereno. Cero hype. Si te decimos que algo no funciona, no funciona — aunque te cobremos por ello.':
    [
      "Calm communication. No hype. If we tell you something doesn't work, it doesn't — even when you're paying us for it.",
      'Comunicação serena. Sem exageros. Se dissermos que algo não funciona, não funciona — mesmo quando você nos paga por isso.',
    ],
  '02 / Valores': ['02 / Values', '02 / Valores'],
  'Cinco vectores.': ['Five vectors.', 'Cinco vetores.'],
  'Mismos de la marca.': ['The same as our brand.', 'Os mesmos da marca.'],
  'Los atributos del manual no son aspiracionales: definen cómo trabajamos. Si un colega no encaja con tres de los cinco, no entra. Si un cliente no encaja, no firmamos.':
    [
      "The brand guidelines' attributes are not aspirations: they define how we work. If a colleague doesn't fit three of the five, they don't join. If a client doesn't fit, we don't sign.",
      'Os atributos do manual não são aspirações: definem como trabalhamos. Se um colega não se encaixa em três dos cinco, não entra. Se um cliente não se encaixa, não assinamos.',
    ],
  'Nivel 01': ['Tier 01', 'Nível 01'],
  'Comisión recurrente': ['Recurring commission', 'Comissão recorrente'],
  'Para agencias que prefieren no entrar al trabajo operativo. Mandas un lead calificado; nosotros lo trabajamos y te pagamos comisión.':
    [
      'For agencies that prefer to stay out of operations. Send a qualified lead; we work it and pay you a commission.',
      'Para agências que preferem não entrar no trabalho operacional. Você envia um lead qualificado; nós cuidamos dele e pagamos uma comissão.',
    ],
  'Comisión recurrente por cliente referido': [
    'Recurring commission for each referred client',
    'Comissão recorrente por cliente indicado',
  ],
  'Pago mensual desde el primer cierre': [
    'Monthly payments from the first deal',
    'Pagamento mensal desde o primeiro contrato',
  ],
  'Tu logo aparece en el reporte': [
    'Your logo appears in the report',
    'Seu logo aparece no relatório',
  ],
  'Sin certificación obligatoria': [
    'No mandatory certification',
    'Sem certificação obrigatória',
  ],
  'Sin mínimo de cuentas': [
    'No minimum number of accounts',
    'Sem mínimo de contas',
  ],
  'Empezar como Referral': [
    'Start as a Referral partner',
    'Começar como Referral',
  ],
  'Nivel 02': ['Tier 02', 'Nível 02'],
  'Margen sobre tu precio': ['Margin on your price', 'Margem sobre seu preço'],
  'Vendes AEO con tu marca y tu precio; nosotros operamos la plataforma y entregamos los reportes co-branded.':
    [
      'Sell AEO under your brand at your price; we operate the platform and deliver co-branded reports.',
      'Venda AEO com sua marca e seu preço; nós operamos a plataforma e entregamos relatórios com as duas marcas.',
    ],
  'Margen sobre tu precio al cliente': [
    'Margin on your client price',
    'Margem sobre seu preço ao cliente',
  ],
  'Reportes co-branded "By Bison"': [
    'Co-branded "By Bison" reports',
    'Relatórios com as duas marcas e selo "By Bison"',
  ],
  'Canal directo con el equipo técnico': [
    'Direct channel with the technical team',
    'Canal direto com a equipe técnica',
  ],
  'Onboarding asistido en tus primeros clientes': [
    'Assisted onboarding for your first clients',
    'Onboarding assistido nos primeiros clientes',
  ],
  'Certificación de fundamentos': [
    'Foundations certification',
    'Certificação de fundamentos',
  ],
  'Postular a Reseller': ['Apply for Reseller', 'Inscrever-se como Reseller'],
  'Nivel 03': ['Tier 03', 'Nível 03'],
  'Margen con tu marca': ['Margin under your brand', 'Margem com sua marca'],
  'Para agencias con varias cuentas de AEO activas que quieren operar con su propia marca, de punta a punta.':
    [
      'For agencies with several active AEO accounts that want to operate under their own brand from end to end.',
      'Para agências com várias contas ativas de AEO que querem operar com a própria marca, de ponta a ponta.',
    ],
  'Plataforma y reportes con tu marca': [
    'Platform and reports under your brand',
    'Plataforma e relatórios com sua marca',
  ],
  'API + webhooks completos': [
    'Full API + webhooks',
    'API + webhooks completos',
  ],
  'Ruta completa de certificación': [
    'Full certification path',
    'Trilha completa de certificação',
  ],
  'Contacto dedicado en Bison': [
    'Dedicated Bison contact',
    'Contato dedicado na Bison',
  ],
  'Postular a White-label': [
    'Apply for White-label',
    'Inscrever-se como White-label',
  ],
  'CEO · Co-founder': ['CEO · Co-founder', 'CEO · Cofundador'],
  'Ingeniero TI · PUC': ['IT Engineer · PUC', 'Engenheiro de TI · PUC'],
  'Emprendedor serial: 8 empresas, 3 activas y 1 exit. Construye la estrategia y el negocio de Bison para convertir visibilidad en ventas.':
    [
      "Serial entrepreneur: eight companies, three active and one exit. Builds Bison's strategy and business to turn visibility into sales.",
      'Empreendedor em série: oito empresas, três ativas e uma venda. Constrói a estratégia e o negócio da Bison para transformar visibilidade em vendas.',
    ],
  'CTO · Co-founder': ['CTO · Co-founder', 'CTO · Cofundador'],
  'Ingeniero Eléctrico · PUC': [
    'Electrical Engineer · PUC',
    'Engenheiro Eletricista · PUC',
  ],
  'Ingeniero de datos y fundador de Vlitzer y Suncast. Construye el motor técnico de Bison que vuelve el ruido de la IA en señal medible.':
    [
      "Data engineer and founder of Vlitzer and Suncast. Builds Bison's technical engine to turn AI noise into measurable signals.",
      'Engenheiro de dados e fundador da Vlitzer e da Suncast. Constrói o motor técnico da Bison que transforma o ruído da IA em sinais mensuráveis.',
    ],
  'CCO · Co-founder': ['CCO · Co-founder', 'CCO · Cofundador'],
  'Ing. Comercial · MBA UChile': [
    'Business Engineer · MBA UChile',
    'Engenheiro Comercial · MBA UChile',
  ],
  'Ing. Comercial y MBA. Más de 10 años liderando equipos comerciales y conectando tecnología con oportunidades de negocio.':
    [
      'Business engineer with an MBA. Over 10 years leading sales teams and connecting technology with business opportunities.',
      'Engenheiro Comercial com MBA. Mais de dez anos liderando equipes comerciais e conectando tecnologia a oportunidades de negócio.',
    ],
  Advisor: ['Advisor', 'Assessor'],
  'Ingeniero Estructural · PUC': [
    'Structural Engineer · PUC',
    'Engenheiro Estrutural · PUC',
  ],
  'PhD en IA y fundador de Cytech y BuildaLab. Aporta el rigor científico de Bison que vuelve los datos complejos en decisiones estratégicas.':
    [
      'PhD in AI and founder of Cytech and BuildaLab. Brings Bison the scientific rigor that turns complex data into strategic decisions.',
      'Doutor em IA e fundador da Cytech e da BuildaLab. Traz à Bison o rigor científico que transforma dados complexos em decisões estratégicas.',
    ],
  'El costo de no aparecer: IA agudiza la brecha digital y relega visibilidad a empresas de regiones frente a grandes marcas':
    [
      'The cost of not appearing: AI widens the digital divide and pushes regional companies behind major brands in visibility',
      'O custo de não aparecer: a IA amplia a exclusão digital e reduz a visibilidade de empresas regionais diante das grandes marcas',
    ],
  'Citó nuestra medición de 312 marcas en 22 industrias regionales de Chile y a Felipe Díaz, cofundador, como vocero.':
    [
      'Cited our measurement of 312 brands across 22 regional industries in Chile, with co-founder Felipe Díaz as spokesperson.',
      'Citou nossa medição de 312 marcas em 22 setores regionais do Chile, com o cofundador Felipe Díaz como porta-voz.',
    ],
  'Preferencias de cookies': ['Cookie preferences', 'Preferências de cookies'],
  Cookies: ['Cookies', 'Cookies'],
  'Usamos cookies analíticas y de marketing solo si las aceptas. Las necesarias siempre están activas. Más detalle en la':
    [
      'We use analytics and marketing cookies only if you accept them. Necessary cookies are always active. Learn more in our',
      'Usamos cookies analíticos e de marketing somente com sua aceitação. Os necessários estão sempre ativos. Mais detalhes na',
    ],
  'Política de Cookies': ['Cookie Policy', 'Política de Cookies'],
  Necesarias: ['Necessary', 'Necessários'],
  'Recuerdan tu elección y hacen funcionar el sitio.': [
    'Remember your choice and keep the site working.',
    'Lembram sua escolha e fazem o site funcionar.',
  ],
  Analíticas: ['Analytics', 'Analíticos'],
  'Google Analytics y Microsoft Clarity: tráfico, mapas de calor y grabaciones de sesión.':
    [
      'Google Analytics and Microsoft Clarity: traffic, heatmaps and session recordings.',
      'Google Analytics e Microsoft Clarity: tráfego, mapas de calor e gravações de sessão.',
    ],
  Marketing: ['Marketing', 'Marketing'],
  'Meta Pixel: medición de campañas en Meta Ads.': [
    'Meta Pixel: campaign measurement in Meta Ads.',
    'Meta Pixel: medição de campanhas no Meta Ads.',
  ],
  'Aceptar todas': ['Accept all', 'Aceitar todos'],
  'Rechazar cookies no necesarias': [
    'Reject non-essential cookies',
    'Rejeitar cookies não essenciais',
  ],
  Rechazar: ['Reject', 'Rejeitar'],
  Guardar: ['Save', 'Salvar'],
  Configurar: ['Configure', 'Configurar'],
  'Enviando…': ['Sending…', 'Enviando…'],
  Directa: ['Direct', 'Direta'],
  'Sin amarre': ['No lock-in', 'Sem fidelidade'],
  Recurrente: ['Recurring', 'Recorrente'],
  Incluida: ['Included', 'Incluída'],
  'TÚ APORTAS': ['YOU BRING', 'VOCÊ TRAZ'],
  'NOSOTROS APORTAMOS': ['WE BRING', 'NÓS TRAZEMOS'],
  'Agente de Monitoreo': ['Monitoring Agent', 'Agente de Monitoramento'],
  'Agente de Diagnóstico': ['Assessment Agent', 'Agente de Diagnóstico'],
  'Agente de Contenido': ['Content Agent', 'Agente de Conteúdo'],
  'Agente de Optimización': ['Optimization Agent', 'Agente de Otimização'],
  Ángeles: ['Angel investors', 'Investidores-anjo'],
  Chile: ['Chile', 'Chile'],
  Brasil: ['Brazil', 'Brasil'],
  México: ['Mexico', 'México'],
  Argentina: ['Argentina', 'Argentina'],
  Colombia: ['Colombia', 'Colômbia'],
  Perú: ['Peru', 'Peru'],
  Uruguay: ['Uruguay', 'Uruguai'],
  España: ['Spain', 'Espanha'],
  Otro: ['Other', 'Outro'],
  Sede: ['Headquarters', 'Sede'],
  Bolivia: ['Bolivia', 'Bolívia'],
  Ecuador: ['Ecuador', 'Equador'],
  Paraguay: ['Paraguay', 'Paraguai'],
  Venezuela: ['Venezuela', 'Venezuela'],
  Guyana: ['Guyana', 'Guiana'],
  Surinam: ['Suriname', 'Suriname'],
  'Guayana Francesa': ['French Guiana', 'Guiana Francesa'],
  'Ver biografía': ['View biography', 'Ver biografia'],
  'Foto de {name}': ['Photo of {name}', 'Foto de {name}'],
  'Foto de {name}, {role} de Bison Agents': [
    'Photo of {name}, {role} at Bison Agents',
    'Foto de {name}, {role} da Bison Agents',
  ],
  'Ver biografía de {name}': [
    "View {name}'s biography",
    'Ver a biografia de {name}',
  ],
  'Perfil de LinkedIn de {name}': [
    "{name}'s LinkedIn profile",
    'Perfil de {name} no LinkedIn',
  ],
  'Ver en el blog: {insight}': [
    'View on the blog: {insight}',
    'Ver no blog: {insight}',
  ],
  '¿Quién está detrás de Bison Agents?': [
    'Who is behind Bison Agents?',
    'Quem está por trás da Bison Agents?',
  ],
  'Tres fundadores con experiencia operando y vendiendo tecnología —Matías Tapia (CEO), Matías Ramírez (CTO) y Felipe Díaz (CCO)—, con Felipe Concha (PhD en Inteligencia Artificial) como asesor. El trabajo repetible —monitoreo, diagnóstico, generación de contenido y ejecución— lo realizan agentes de IA.':
    [
      'Three founders with experience operating and selling technology — Matías Tapia (CEO), Matías Ramírez (CTO) and Felipe Díaz (CCO) — with Felipe Concha (PhD in Artificial Intelligence) as an advisor. AI agents perform the repeatable work: monitoring, assessment, content generation and execution.',
      'Três fundadores com experiência operando e vendendo tecnologia — Matías Tapia (CEO), Matías Ramírez (CTO) e Felipe Díaz (CCO) —, com Felipe Concha (doutor em Inteligência Artificial) como assessor. Agentes de IA realizam o trabalho repetitivo: monitoramento, diagnóstico, geração de conteúdo e execução.',
    ],
  '¿Qué experiencia respalda al equipo?': [
    'What experience backs the team?',
    'Que experiência sustenta a equipe?',
  ],
  'Operadores, no consultores: antes de Bison fundamos, escalamos y vendimos empresas de tecnología —ocho compañías, un exit— y sumamos un PhD en Inteligencia Artificial. Esa experiencia la usamos para construir producto, no para entregar recomendaciones. Y lo demostramos con el ejemplo: el Score AEO de Bison es público y se mide con la misma metodología que aplicamos a cada cliente.':
    [
      "Operators, not consultants: before Bison, we founded, scaled and sold technology companies — eight companies, one exit — and brought in a PhD in Artificial Intelligence. We use that experience to build products rather than deliver recommendations. We demonstrate it ourselves: Bison's AEO Score is public and uses the same methodology we apply to every client.",
      'Operadores, não consultores: antes da Bison, fundamos, expandimos e vendemos empresas de tecnologia — oito empresas, uma venda — e reunimos um doutor em Inteligência Artificial. Usamos essa experiência para construir produtos, em vez de entregar recomendações. Damos o exemplo: o Score AEO da Bison é público e medido com a mesma metodologia aplicada a cada cliente.',
    ],
  '¿Bison es una agencia o software?': [
    'Is Bison an agency or software?',
    'A Bison é uma agência ou um software?',
  ],
  'El core es software, con modelo SaaS: la plataforma mide, diagnostica y genera el contenido, y los agentes de IA ejecutan el trabajo repetible a escala. Puedes usar Bison de forma autónoma —es simple e intuitivo y el Bison Agent, el copiloto integrado, resuelve dudas dentro del producto—: recibes diagnóstico, monitoreo semanal y el contenido para cerrar las brechas. Quien lo quiera puede sumar un servicio premium de acompañamiento, donde nuestro equipo define la estrategia contigo y, en el plan Enterprise, ejecuta y publica de punta a punta. Es opcional y se suma al producto, no lo reemplaza: lo que escala y sostiene el valor es la plataforma, no las horas de un consultor.':
    [
      'The core is SaaS software: the platform measures, assesses and generates content, while AI agents perform repeatable work at scale. You can use Bison independently — it is simple and intuitive, and Bison Agent, the built-in copilot, answers questions inside the product. You receive an assessment, weekly monitoring and content to close the gaps. You can also add a premium advisory service, where our team defines the strategy with you and, on the Enterprise plan, executes and publishes end to end. This is optional and complements the product: the platform delivers scalable, lasting value.',
      'A base é um software SaaS: a plataforma mede, diagnostica e gera conteúdo, enquanto agentes de IA executam o trabalho repetitivo em escala. Você pode usar a Bison de forma autônoma — ela é simples e intuitiva, e o Bison Agent, copiloto integrado, responde às dúvidas dentro do produto. Você recebe diagnóstico, monitoramento semanal e conteúdo para preencher lacunas. Também é possível adicionar um serviço premium de acompanhamento, no qual nossa equipe define a estratégia com você e, no plano Enterprise, executa e publica de ponta a ponta. Esse serviço é opcional e complementa o produto: é a plataforma que entrega valor duradouro e escalável.',
    ],
  '¿Por qué se llama Bison Agents?': [
    'Why is it called Bison Agents?',
    'Por que se chama Bison Agents?',
  ],
  '"Agents" por los agentes de IA que operan dentro de la plataforma —monitoreo, diagnóstico, generación de contenido y ejecución—, que hacen el trabajo repetible a escala. Y "Bison" por su instinto de enfrentar el cambio de frente: en la búsqueda con IA, la marca que ajusta su presencia a tiempo es la que los motores encuentran, entienden y recomiendan.':
    [
      '"Agents" refers to the AI agents inside the platform — monitoring, assessment, content generation and execution — that perform repeatable work at scale. "Bison" reflects the instinct to face change head-on: in AI search, brands that adjust their presence in time are the ones engines find, understand and recommend.',
      '"Agents" vem dos agentes de IA que operam na plataforma — monitoramento, diagnóstico, geração de conteúdo e execução — e fazem o trabalho repetitivo em escala. "Bison" representa o instinto de enfrentar a mudança de frente: na busca com IA, as marcas que ajustam sua presença a tempo são encontradas, compreendidas e recomendadas pelos motores.',
    ],
  '¿Dónde están ubicados?': [
    'Where are you based?',
    'Onde vocês estão localizados?',
  ],
  'Operamos desde Santiago de Chile —domicilio en Las Condes— y atendemos clientes en toda LatAm de forma remota, sin importar dónde esté tu equipo. La metodología es la misma en cualquier país; lo que varía es el catálogo de motores que priorizamos según tu mercado y audiencia.':
    [
      'We operate from Santiago, Chile, with an address in Las Condes, and serve clients remotely across Latin America, wherever their teams are. The methodology is the same in every country; we prioritize different engines according to your market and audience.',
      'Operamos a partir de Santiago do Chile, com endereço em Las Condes, e atendemos clientes remotamente em toda a América Latina, onde quer que suas equipes estejam. A metodologia é a mesma em qualquer país; priorizamos motores diferentes conforme seu mercado e público.',
    ],
  '¿La demo o el diagnóstico tienen costo?': [
    'Does the demo or assessment cost anything?',
    'A demonstração ou o diagnóstico têm algum custo?',
  ],
  'No. La primera llamada dura unos 30 minutos y es un diagnóstico sin compromiso: revisamos cómo aparece hoy tu marca en ChatGPT, Gemini y Perplexity y dónde están tus brechas. Te llevas esa lectura inicial aunque decidas no avanzar — sin costo ni obligación de contratar después.':
    [
      'No. The first call lasts about 30 minutes and is a no-obligation assessment: we review how your brand appears today in ChatGPT, Gemini and Perplexity and identify the gaps. You keep that initial assessment even if you decide not to proceed, at no cost or obligation to subscribe.',
      'Não. A primeira conversa dura cerca de 30 minutos e é um diagnóstico sem compromisso: avaliamos como sua marca aparece hoje no ChatGPT, Gemini e Perplexity e identificamos as lacunas. Você fica com essa leitura inicial mesmo se decidir não seguir adiante, sem custo ou obrigação de contratar.',
    ],
  '¿Necesito preparar algo para la primera llamada?': [
    'Do I need to prepare anything for the first call?',
    'Preciso preparar algo para a primeira conversa?',
  ],
  'Nada obligatorio. Con la URL de tu sitio nos basta para llegar preparados. Si quieres aprovecharla más, ten a mano tus competidores principales y en qué motores de IA te interesa aparecer.':
    [
      'Nothing is required. Your website URL is enough for us to come prepared. To make the most of the call, have your main competitors and the AI engines where you want to appear in mind.',
      'Nada é obrigatório. A URL do seu site já é suficiente para chegarmos preparados. Para aproveitar melhor a conversa, tenha em mente seus principais concorrentes e os motores de IA nos quais gostaria de aparecer.',
    ],
  '¿Hay algún compromiso o permanencia después de la demo?': [
    'Is there any commitment or lock-in after the demo?',
    'Existe algum compromisso ou fidelidade depois da demonstração?',
  ],
  'Ninguno. La demo no obliga a contratar, y los planes no tienen contratos de permanencia: cancelas cuando quieras. El plan anual es opcional y solo existe porque incluye un 15% de descuento.':
    [
      'None. The demo does not require you to subscribe, and plans have no lock-in contracts: cancel whenever you want. The annual plan is optional and includes a 15% discount.',
      'Nenhum. A demonstração não obriga a contratar, e os planos não têm contrato de fidelidade: você cancela quando quiser. O plano anual é opcional e inclui 15% de desconto.',
    ],
  '¿Puedo escribirles directo por email en vez del formulario?': [
    'Can I email you directly instead of using the form?',
    'Posso enviar um e-mail diretamente em vez de usar o formulário?',
  ],
  'Claro: hello@bisonagents.com para temas generales, legal@bisonagents.com y support@bisonagents.com para temas específicos. El formulario solo nos ayuda a llegar preparados a la primera llamada; no es obligatorio.':
    [
      "Of course: hello@bisonagents.com for general questions, and legal@bisonagents.com or support@bisonagents.com for specific topics. The form only helps us prepare for the first call; it isn't required.",
      'Claro: hello@bisonagents.com para assuntos gerais, e legal@bisonagents.com ou support@bisonagents.com para assuntos específicos. O formulário apenas nos ajuda a preparar a primeira conversa; ele não é obrigatório.',
    ],
  '¿Qué hacen con los datos que envío en el formulario?': [
    'What do you do with the data I submit in the form?',
    'O que vocês fazem com os dados enviados no formulário?',
  ],
  'Solo los usamos para responder tu solicitud y coordinar la conversación. No los vendemos ni los compartimos con terceros. El detalle está en nuestra Política de privacidad.':
    [
      "We only use it to answer your request and coordinate the conversation. We don't sell it or share it with third parties. See our Privacy Policy for details.",
      'Usamos os dados apenas para responder à sua solicitação e combinar a conversa. Não vendemos nem compartilhamos com terceiros. Os detalhes estão na nossa Política de Privacidade.',
    ],
  'Directo con el equipo': ['Directly with the team', 'Direto com a equipe'],
  'Falkland Is.': ['Falkland Islands', 'Ilhas Malvinas (Falkland)'],
};
